// Centralized API base.
// Fix: in production REACT_APP_BACKEND_URL points to the bare apex domain
// (trinityoungorchestra.eu) which 308-redirects to www. CORS-preflighted
// requests (POST/JSON) and auth headers break across that redirect, so we
// normalize the apex host to its www variant which is served without redirect.
function computeApiBase() {
  const raw = process.env.REACT_APP_BACKEND_URL || "";
  try {
    const u = new URL(raw);
    if (u.hostname === "trinityoungorchestra.eu") {
      u.hostname = "www.trinityoungorchestra.eu";
      return `${u.origin}/api`;
    }
    return `${u.origin}/api`;
  } catch (e) {
    return `${raw}/api`;
  }
}

export const API = computeApiBase();
